import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentSletting } from "@/components/DocumentSletting/DocumentSletting";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/opprett-sletting/")({
  loader: async ({ params }) => {
    const { tluxCaseId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sletting.defaults.$get({
      param: {
        tluxCaseId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch sletting template");
    }

    return {
      sletting: await res.json(),
    };
  },
  head: () => {
    return {
      meta: [{ title: "Opprett sletting | Alice & Bob" }],
    };
  },
  component: Page,
});

function Page() {
  const { tluxCaseId } = Route.useParams();
  const { sletting } = Route.useLoaderData();

  return (
    <CustomerLayout>
      <DocumentSletting tluxCaseId={tluxCaseId} sletting={sletting} cancelUrl={`/oppdrag/${tluxCaseId}`} />
    </CustomerLayout>
  );
}
